// src/App.js
//import React, { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { AuthProvider, useAuth } from './auth/AuthProvider';
import Header from './components/Header';
import SelectionPage from './pages/SelectionPage';
import LeadPayPage from './pages/LeadPayPage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import SignInPage from './pages/SignInPage';
import './index.css';

// ── Inner app — rendered after auth is resolved ───────────────────────────────
function AppRoutes() {
  const { associateId, authFailure } = useAuth();

  //if (isLoading) return <LoadingPage message="Verifying access…" />;

  // Signed in to Entra, but the API would not grant access. This is its own screen —
  // falling back to SignInPage here used to dead-end the user: on a machine signed
  // into Windows with a shared departmental account, clicking "Sign in" again just
  // passed the same account through and produced the same failure, with no way out.
  if (authFailure) return <UnauthorizedPage />;

  // Not signed in — show sign in page
  if (!associateId) return <SignInPage />;

  return (
    <AppProvider>
      <Header />
      <Routes>
        <Route path="/"             element={<SelectionPage />} />
        <Route path="/leadpay"      element={<LeadPayPage />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="*"             element={<Navigate to="/" replace />} />
      </Routes>
    </AppProvider>
  );
}

// ── Root app — handles MSAL initialization ────────────────────────────────────
export default function App() {
  // const [msalReady, setMsalReady] = useState(false);

  // useEffect(() => {
  //   console.log('Initializing MSAL...');
  //   ensureMsalInitialized()
  //     .then(() => {
  //       console.log('MSAL initialized successfully');
  //       setMsalReady(true)
  //     })
  //     .catch(err => console.error('[MSAL] Initialization failed:', err));
  // }, []);

  // if (!msalReady) return <LoadingPage message="Initializing…" />;

  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
